import moment from "moment-mini-ts";

export const fmtDay = (epochMilis: number) =>
  moment(epochMilis).format("MMM D, YYYY");
